<template>
	<table>
		<thead>
			<tr>
				<th v-for="(column, prop) in columns" :key="prop">
					<slot :name="'header-' + prop">
						{{ column }}
					</slot>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="(row, index) in rows"
				:key="index"
				:class="{ hidden: row.visible === false }"
			>
				<td v-for="(_, prop) in columns" :key="prop">
					<slot :name="'cell-' + prop" :row="row">
						{{ row[prop] }}
					</slot>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	props: {
		columns: { type: Object, required: true },
		rows: { type: Array, required: true },
	},
}
</script>

<style lang="scss" scoped>
table {
	border-collapse: separate;
	border-spacing: 0;
	width: 100%;
}
</style>
